import React from 'react';
import FormSelect from '../../common/FormSelect';
import { useTranslation } from 'react-i18next';
import { Company } from '../../../types/company';

export interface CompanyOption {
  id: string | number;
  companyName: string;
}

export interface CompanyFormSelectProps {
  company: string | number | undefined | null;
  companies: Company[] | null | undefined;
  handleCompanyChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

export default function CompanyFormSelect({
  company,
  companies,
  handleCompanyChange,
}: CompanyFormSelectProps) {
  const { t } = useTranslation();
  return (
    <>
      <FormSelect
        name="company"
        label={t('Company')}
        onChange={handleCompanyChange}
        defaultValue={company}
      >
        <option value="">{t('---all---')}</option>
        {companies &&
          [...companies]
            ?.sort((a, b) => a.companyName.localeCompare(b.companyName))
            .map((x) => (
              <option key={x.id} value={x.id}>
                {x.companyName}
              </option>
            ))}
      </FormSelect>
    </>
  );
}
